module.exports = __webpack_public_path__ + "assets/HKNova-ExtraBold.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraBold.woff
// module id = 119
// module chunks = 0